import {Directive, OnInit, TemplateRef, ViewContainerRef} from '@angular/core';

import {YiitService} from '../services/yiit.service';

@Directive({
  selector: '[yiiTranslate]',
})
export class YiitDirective implements OnInit {
  constructor(
    private templateRef: TemplateRef<unknown>,
    private viewContainerRef: ViewContainerRef,
    private yiitService: YiitService
  ) {}

  ngOnInit(): void {
    this.viewContainerRef.clear();
    this.viewContainerRef.createEmbeddedView(this.templateRef, {
      $implicit: (text: string, params: string[]) =>
        this.yiitService.translate(text, params),
    });
  }
}
